var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
let CurrencyInput = class CurrencyInput extends Vue {
    constructor() {
        super(...arguments);
        this.displayValue = '';
    }
    onValueChanged(newValue) {
        if (newValue === null || newValue === undefined || isNaN(newValue)) {
            if (this.displayValue !== '') {
                this.displayValue = '';
            }
            return;
        }
        const formatted = this.formatBRL(newValue);
        if (formatted !== this.displayValue) {
            this.displayValue = formatted;
        }
    }
    handleInput(val) {
        if (!val) {
            this.displayValue = '';
            this.$emit('input', null);
            return;
        }
        let digits = val.replace(/\D/g, '');
        // Remove leading zeros
        digits = digits.replace(/^0+/, '');
        // Limit to 14 digits (12 for integer part + 2 for decimals)
        if (digits.length > 14) {
            digits = digits.slice(0, 14);
        }
        if (!digits) {
            this.displayValue = '0,00';
            this.$emit('input', 0);
            return;
        }
        // Pad with zeros to ensure at least 3 digits (e.g., "1" -> "001" -> "0,01")
        if (digits.length < 3) {
            digits = digits.padStart(3, '0');
        }
        const numericValue = parseInt(digits, 10) / 100;
        this.displayValue = this.formatBRL(numericValue);
        this.$emit('input', numericValue);
    }
    handleFocus(event) {
        this.$emit('focus', event);
    }
    handleBlur(event) {
        this.$emit('blur', event);
    }
    formatBRL(value) {
        return new Intl.NumberFormat('pt-BR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(value);
    }
    validate() {
        // @ts-ignore
        return this.$refs.qinput.validate();
    }
    resetValidation() {
        // @ts-ignore
        return this.$refs.qinput.resetValidation();
    }
};
__decorate([
    Prop({ default: null })
], CurrencyInput.prototype, "value", void 0);
__decorate([
    Prop({ default: 'grey-2' })
], CurrencyInput.prototype, "bgColor", void 0);
__decorate([
    Prop({ default: 'grey-2' })
], CurrencyInput.prototype, "labelColor", void 0);
__decorate([
    Prop({ default: 'grey-2' })
], CurrencyInput.prototype, "color", void 0);
__decorate([
    Prop()
], CurrencyInput.prototype, "inputClass", void 0);
__decorate([
    Prop({ default: () => ({ 'padding-top': '0', 'padding-bottom': '0' }) })
], CurrencyInput.prototype, "inputStyle", void 0);
__decorate([
    Prop({ default: false })
], CurrencyInput.prototype, "disabled", void 0);
__decorate([
    Prop({ default: false })
], CurrencyInput.prototype, "loading", void 0);
__decorate([
    Prop({ default: () => [] })
], CurrencyInput.prototype, "rules", void 0);
__decorate([
    Prop({ default: false })
], CurrencyInput.prototype, "error", void 0);
__decorate([
    Prop({ default: '' })
], CurrencyInput.prototype, "errorMessage", void 0);
__decorate([
    Prop({ default: true })
], CurrencyInput.prototype, "bottomSlots", void 0);
__decorate([
    Prop({ default: false })
], CurrencyInput.prototype, "hideBottomSpace", void 0);
__decorate([
    Watch('value', { immediate: true })
], CurrencyInput.prototype, "onValueChanged", null);
CurrencyInput = __decorate([
    Component({
        name: 'CurrencyInput',
    })
], CurrencyInput);
export default CurrencyInput;
